import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { useSearch } from "../../context/SearchContext";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import getCities from "../../services/getCities.js";
import Cancelar from "../../assets/Cancelar.png";

const Searcher2 = () => {
    const { city, setCity, checkIn, setCheckIn, checkOut, setCheckOut, guests, setGuests, tag, setTag, tags, setTags, handleSearch } = useSearch();

    const [cities, setCities] = useState([]);
    const [resultCities, setResultCities] = useState([]);
    const [dateRange, setDateRange] = useState([null, null]);
    const [start_Date, end_Date] = dateRange || ["", ""];
    const [openCalendar, setOpenCalendar] = useState(false);
    const [searchParams] = useSearchParams();

    const navigate = useNavigate()

    const handleValidation = () => {

        if (!city) {
            Swal.fire({
                imageUrl: Cancelar,
                imageWidth: 80,
                imageHeight: 80,
                title: 'Destino requerido',
                text: 'Por favor, selecciona un destino.',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: true,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#1F4F51',
                customClass: {
                    confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",

                },
            });
            return false;
        }
        // if (!start_Date || !end_Date) {
        //     Swal.fire({
        //         imageUrl: Cancelar,
        //         imageWidth: 80,
        //         imageHeight: 80,
        //         title: 'Fechas requeridas',
        //         text: 'Por favor, selecciona las fechas de llegada y salida.',
        //         timer: 5000,
        //         timerProgressBar: true,
        //         showConfirmButton: true,
        //         confirmButtonText: 'Entendido',
        //         confirmButtonColor: '#1F4F51',
        //         customClass: {
        //             confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",

        //         },
        //     });
        //     return false;
        // }
        // if (end_Date < start_Date) {
        //     Swal.fire({
        //         imageUrl: Cancelar,
        //         imageWidth: 80,
        //         imageHeight: 80,
        //         title: 'Fechas inválidas',
        //         text: 'La fecha de salida no puede ser anterior a la de llegada.',
        //         timer: 5000,
        //         timerProgressBar: true,
        //         showConfirmButton: true,
        //         confirmButtonText: 'Entendido',
        //         confirmButtonColor: '#1F4F51',
        //         customClass: {
        //             confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        //         }
        //     });
        //     return false;
        // }
        // if (end_Date.getTime() == start_Date.getTime()) {
        //     Swal.fire({
        //         imageUrl: Cancelar,
        //         imageWidth: 80,
        //         imageHeight: 80,
        //         title: 'Fechas inválidas',
        //         text: 'La fecha de salida no puede ser igual a la de llegada.',
        //         timer: 5000,
        //         timerProgressBar: true,
        //         showConfirmButton: true,
        //         confirmButtonText: 'Entendido',
        //         confirmButtonColor: '#1F4F51',
        //         customClass: {
        //             confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        //         }
        //     });
        //     return false;
        // }
        if (!guests) {
            Swal.fire({
                imageUrl: Cancelar,
                imageWidth: 80,
                imageHeight: 80,
                title: 'Número de huéspedes',
                text: 'Por favor, selecciona el número de huéspedes.',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: true,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#1F4F51',
                customClass: {
                    confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",

                },
            });
            return false;
        }
        return true;
    };

    const handleClick = () => {
        if (handleValidation()) {
            try {
                const params = {
                    city,
                    guests,
                    tag,
                    checkIn,
                    checkOut
                }

                handleSearch(params)
                navigate(`/listings?city=${encodeURIComponent(city)}&checkIn=${encodeURIComponent(checkIn)}&checkOut=${encodeURIComponent(checkOut)}&guests=${encodeURIComponent(guests)}&tag=${encodeURIComponent(tag)}`);
            } catch (error) {
                console.error("Error obteniendo los resultados:", error);
            }
        }
    };

    const handleDateChange = (update) => {
        setDateRange(update);

        if (update[0] && update[1]) {
            const checkInDate = update[0].toISOString().split("T")[0];
            const checkOutDate = update[1].toISOString().split("T")[0];
            setCheckIn(checkInDate);
            setCheckOut(checkOutDate);
            setOpenCalendar(false);
        }
    };

    const handleCities = (city) => {
        setCity(city)
        const filterTags = resultCities?.cities[city] || []
        setTags(filterTags)
        setTag("")

    }

    useEffect(() => {
        const fetchCities = async () => {
            const responseCities = await getCities();
            setCities(Object.keys(responseCities.cities));
            setResultCities(responseCities)
        };
        fetchCities();
        setCity(searchParams.get("city"))
        setCheckIn(searchParams.get("checkIn"))
        setCheckOut(searchParams.get("checkOut"))
        setGuests(searchParams.get("guests"))
        setTag(searchParams.get("tag"))

        const checkInParam = searchParams.get("checkIn");
        const checkOutParam = searchParams.get("checkOut");
        let defaultStartDate = "";
        let defaultEndDate = "";

        if (checkInParam && checkOutParam) {
            defaultStartDate = new Date(`${checkInParam}T00:00:00`);
            defaultEndDate = new Date(`${checkOutParam}T00:00:00`);
            if (isNaN(defaultStartDate.getTime()) || isNaN(defaultEndDate.getTime())) {
                defaultStartDate = "";
                defaultEndDate = "";
            }
        }

        setDateRange([defaultStartDate, defaultEndDate].filter(Boolean));
    }, []);
    useEffect(() => {
        if (resultCities && resultCities.cities) {
            const filterTags = resultCities.cities[city] || [];
            setTags(filterTags)
        }
    }, [resultCities]);


    return (
        <div className="relative w-full h-[200px] font-poppins flex justify-center">
            <div className="bg-white p-4 rounded-2xl shadow-md max-w-md w-full">
                <div className="grid grid-cols-[30%,65%] gap-3">
                    {/* Selección de Ciudad */}
                    <div className="flex flex-col">
                        <label className="text-xs font-medium text-gray-600">Destino:</label>
                        <select
                            value={city}
                            className="appearance-none border-none bg-transparent text-sm text-gray-700 focus:outline-none w-full px-0"
                            onChange={(e) => handleCities(e.target.value)}
                        >
                            <option value="" disabled hidden>
                                Selecciona
                            </option>
                            {cities.map((city, index) => (
                                <option key={index} value={city}>
                                    {city}
                                </option>
                            ))}
                        </select>
                    </div>



                    <div className="flex flex-col">
                        <label className="text-xs font-medium text-gray-600">Fechas:</label>
                        <div className="relative z-50">
                            <DatePicker
                                selected={start_Date}
                                onChange={(update) => handleDateChange(update)}
                                startDate={start_Date}
                                endDate={end_Date}
                                selectsRange
                                shouldCloseOnSelect={true}
                                open={openCalendar}
                                onClickOutside={() => setOpenCalendar(false)}
                                onFocus={() => setOpenCalendar(true)}
                                minDate={new Date()}
                                placeholderText="Llegada / salida"
                                className=" border-none text-sm text-lefth !w-[80%]"
                            />
                        </div>
                    </div>

                    {/* Sector */}
                    <div className="flex flex-col">
                        <label className="text-xs font-medium text-gray-600">Sector:</label>
                        <select
                            value={tag}
                            className="appearance-none border-none bg-transparent text-sm text-gray-700 focus:outline-none w-full px-0"
                            onChange={(e) => setTag(e.target.value)}
                        >
                            <option value="">
                                TODOS
                            </option>
                            {tags.map((tag) => (
                                <option key={tag.id_tag} value={tag.name_tag}>
                                    {tag.name_tag}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Selección de Huéspedes */}
                    <div className="flex flex-col">
                        <label className="text-xs font-medium text-gray-600">Huéspedes:</label>
                        <select
                            value={guests}
                            onChange={(e) => setGuests(e.target.value)}
                            className="appearance-none border-none bg-transparent text-sm text-gray-700 focus:outline-none w-full px-0"
                        >
                            {[...Array(15)].map((_, i) => (
                                <option key={i} value={i + 1}>
                                    {i + 1} Huésped{i > 0 ? "es" : ""}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Botón de búsqueda con icono */}
                    <div className="col-span-2 flex justify-center mt-2">
                        <button
                            onClick={handleClick}
                            className="bg-[#1F4F51] text-white text-sm font-semibold rounded-lg px-4 py-2 flex items-center justify-center w-full hover:bg-[#17403F] transition"
                        >
                            <Search size={16} className="mr-1" />
                            Buscar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Searcher2;
